import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { visitsKeys } from '../../api/query-keys/visits';

import { visitorsKeys } from '@/features/visitors/api/query-keys/visitors';
import { visitsApi } from '@/features/visits/api/lib/visits';
import { ApiError } from '@/types/interfaces/api-error';

export const useConfirmVisit = (onSuccess?: () => void) => {
  const { t } = useTranslation(['visit']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (visitId: number) => visitsApi.confirmVisit(visitId),
    onSuccess: async () => {
      // Small delay to ensure meilisearch has time to update
      await new Promise(resolve => setTimeout(resolve, 1000));

      queryClient.invalidateQueries({
        queryKey: visitsKeys.all,
      });
      queryClient.invalidateQueries({
        queryKey: visitorsKeys.all,
      });
      toast.success(t('visit:status.confirmed'));
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
